// Style
import styles from './SectionAvis.module.css';

function SectionAvis() {
  
  return (
    <div className={styles.bg}>
      <div className={styles.container}>
        <iframe
          src="https://www.societe-des-avis-garantis.fr/wp-content/plugins/ag-core/widgets/iframe/2/h/?id=11853"
          title="Avis vérifiés"
          height={221}
          width="100%"
        />
      </div>
    </div>
  );
}

export default SectionAvis;
